import { dialogPortal } from '@/modules/common/helpers/portal';
import PasswordDialog from './PasswordDialog.vue';

export const passwordConfirmation = async () => dialogPortal(PasswordDialog);
